import { useTranslation } from 'react-i18next'
import React from 'react'
import { NotificationBody } from 'components/Notification/NotificationBody/NotificationBody'
import { RouteNotificationContent } from 'components/Notification/NotificationContent/RouteNotificationContent'
import { useHistory } from 'react-router-dom'

export default function OrderAcceptedForFulfillmentNotification ({ item, content, onNotificationUpdate, bodyClassName }) {
  const { t } = useTranslation()
  const history = useHistory()

  function goToOrder () {
    history.push('/orders/details/' + content.orderId)
  }

  const acceptedOrderData = {
    referenceId: content.referenceId,
    readableId: content.readableId
  }

  return <NotificationBody title={'notificationsList.orderAcceptedForFulfillment.title'}
                           item={item}
                           footerLeftContent={content.registrationNumber}
                           onNotificationUpdate={onNotificationUpdate}
                           bodyClassName={bodyClassName}>
    <RouteNotificationContent item={item}
                              content={content}
                              additionalInfo={t('notificationsList.orderAcceptedForFulfillment.content', acceptedOrderData)}
                              onNotificationUpdate={onNotificationUpdate}
                              action={{
                                label: 'notificationsList.goToOrder',
                                isShow: true,
                                onClick: goToOrder
                              }}/>
  </NotificationBody>
}
